import React from 'react'

import template from './review-3.twig'

import parse from 'html-react-parser'

import {
  ButtonOptions,
  ContentOptions,
  HeadlineOptions,
  LinkOptions,
} from '@miro-site/components_utils'

export interface Image {
  src: string
  alt: string
}

export interface Review3Props {
  background: 'blue' | 'pink' | 'yellow'
  image?: Image
  headline: HeadlineOptions
  name: ContentOptions
  post: ContentOptions
  logo?: Image
  link?: LinkOptions
  button?: ButtonOptions
  children?: React.ReactNode
}

import 'lazysizes'
import 'lazysizes/plugins/attrchange/ls.attrchange'

const Review3 = (props: Review3Props): React.ReactElement => {
  return (
    <>
      {parse(
        template({...props, component_name: 'Review Section', ctf_assets: 'images.ctfassets.net'}),
      )}
    </>
  )
}

export default Review3
